import { useState, useEffect } from "react";
import { isConfigured, registerUnauthenticatedHandler } from "./api/client.js";
import { ApiKeySetup } from "./components/ApiKeySetup.js";
import { SignIn } from "./components/SignIn.js";
import { ErrorBoundary } from "./components/ErrorBoundary.js";
import { V4App } from "./v4/V4App.js";

export function App() {
  const [configured, setConfigured] = useState(isConfigured);
  const [authenticated, setAuthenticated] = useState(true);

  useEffect(() => {
    registerUnauthenticatedHandler(() => setAuthenticated(false));
    function onUnauthenticated() {
      setAuthenticated(false);
    }
    window.addEventListener("pwa-unauthenticated", onUnauthenticated);
    return () => window.removeEventListener("pwa-unauthenticated", onUnauthenticated);
  }, []);

  if (!configured) {
    return <ApiKeySetup onSave={() => setConfigured(true)} />;
  }

  if (!authenticated) {
    return <SignIn />;
  }

  return (
    <ErrorBoundary name="v4">
      <V4App />
    </ErrorBoundary>
  );
}
